import React, { useState, useRef, useEffect } from "react";
import { FaPaperclip, FaTrashAlt } from "react-icons/fa";

const FileUpload = ({ handleChange, files: parentFiles }) => {
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);

  useEffect(() => {
    // When parent files change, update the child component files
    setFiles(parentFiles);
  }, [parentFiles]);

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    if (event.target.files) {
      const selectedFiles = Array.from(event.target.files);
  
      // Combine the new selected files with the previous files
      setFiles((prevFiles) => {
        const updatedFiles = [...prevFiles, ...selectedFiles];
  
        // After updating state, notify the parent with the combined list of files
        if (handleChange) {
          handleChange(updatedFiles); // Pass the updated list to the parent
        }
  
        return updatedFiles; // Return the updated list to update the state
      });
    }
  };
  
  

  const handleDelete = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
    if (handleChange) {
      handleChange(updatedFiles); // Notify parent of the deleted files
    }
  };

  return (
    <div style={{width: "100%"}}>
      <div style={styles.fileContainer}>
        {files.map((file, index) => (
          <div key={index} style={styles.fileItem}>
            <span style={styles.fileName}>{file.name}</span>
            <button
              onClick={() => handleDelete(index)}
              style={styles.deleteButton}
            >
              <FaTrashAlt />
            </button>
          </div>
        ))}
      </div>
      <div style={{ display: "flex", justifyContent: "flex-end"}}>
      <button onClick={handleIconClick} style={styles.uploadButton}>
        <FaPaperclip />
      </button></div>
      <input
        type="file"
        multiple
        onChange={handleFileChange}
        ref={fileInputRef}
        style={{ display: "none" }}
      />
    </div>
  );
};

const styles = {
  fileContainer: {
    display: "flex",
    flexWrap: "wrap", // Allow wrapping to the next line
    gap: "10px", // Space between file items
    // display: "flex",
    justifyContent: "flex-start",
  },
  fileItem: {
    display: "flex",
    alignItems: "center",
    padding: "5px 10px",
    backgroundColor: "#f1f1f1",
    borderRadius: "15px",
    maxWidth: "200px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  fileName: {
    marginRight: "5px",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  deleteButton: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    padding: "0 5px",
    color: "#ff0000",
  },
  uploadButton: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: "1.5rem",
    color: "#007bff",
  },
};

export default FileUpload;
